import z from "zod";
import type { UgyldigAvtaleÅrsak } from "@/api/generated";

export const fjernAvtaleFormSchema = z
  .object({
    årsak: z.enum([
      "Annet",
      "IngenKundeForhold",
    ] satisfies UgyldigAvtaleÅrsak[]),
    meldingTilBruker: z.string().max(1000),
    bekreftelse: z.boolean().nullable(),
  })
  .refine((val) => val.bekreftelse === true, {
    message: "pages.fjern-avtaler.form.bekreft-required",
  });

export type FjernAvtaleFormSchema = z.infer<typeof fjernAvtaleFormSchema>;

export function initFormValues(
  meldingTilBruker?: string,
): FjernAvtaleFormSchema {
  return {
    årsak: "Annet",
    meldingTilBruker: meldingTilBruker ?? "",
    bekreftelse: false,
  };
}
